<template>
  <a-modal
    :title="model.id === 0 ? '新建角色' : '编辑角色'"
    :width="640"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <!-- 检查是否有 id 并且大于0，大于0是修改。其他是新增，新增不显示主键ID -->
        <a-form-item v-show="false" label="主键ID">
          <a-input v-decorator="['id', { initialValue: model.id || 0 }]" disabled />
        </a-form-item>
        <a-form-item label="角色名称">
          <a-input v-decorator="['name', {rules: [{required: true, min: 1, message: '请输入角色名称'}], initialValue: model.name}]" />
        </a-form-item>
        <a-form-item label="菜单权限">
          <div v-for="(items, index) in menuList" :key="items.id">
            <div :style="{ borderBottom: '1px solid #E9E9E9' }">
              <a-checkbox :checked="checkAll[index]" @change="onCheckAllChange(index)">
                <font style="font-weight:bold; color:#2471A3">{{ items.menuName }}</font>
              </a-checkbox>
            </div>
            <a-checkbox-group v-model="menuSelected[index]" :options="toList(items.children)" @change="onChange" style="margin-top:5px;"/>
          </div>
        </a-form-item>
        <a-form-item label="菜单权限列表" v-show="false" >
          <a-select
            mode="tags"
            :token-separators="[',']"
            v-decorator="['menuIds', { initialValue: model.menuIds}]">
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
// import { TreeSelect } from 'ant-design-vue'
import { getMenuList } from '@/api/permission/menu/index'

// 表单字段
const fields = ['description', 'id']
const plainOptions = ['权限1', '权限2', '权限3']
const defaultCheckedList = ['权限1', '权限3']

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  components: {
    // TreeSelect
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      form: this.$form.createForm(this),
      checkedList: defaultCheckedList,
      indeterminate: false,
      checkAll: [],
      plainOptions,
      menuList: [],
      menuSelected: []
    }
  },
  methods: {
    // 获取菜单
    getMenu () {
      // this.areaTree = []
      this.menuList = []
      this.menuSelected = []
      var list = []
      var param = {}
      return new Promise((resolve, reject) => {
        getMenuList(param).then(res => {
          // console.log(this.model.menuIds)
          this.menuList = res.data
          // console.log(this.menuList)
          if (this.model.menuIds && this.model.menuIds !== []) {
            for (let i = 0; i < res.data.length; i++) {
              list[i] = []
              for (let j = 0; j < res.data[i].children.length; j++) {
                for (let k = 0; k < this.model.menuIds.length; k++) {
                  if (res.data[i].children[j].id === this.model.menuIds[k]) {
                    list[i].push(res.data[i].children[j].menuName)
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < res.data.length; i++) {
              list[i] = []
            }
          }
          this.menuSelected = list
          //
          for (let i = 0; i < res.data.length; i++) {
            if (this.menuSelected[i] !== [] && this.menuSelected[i].length === this.toList(res.data[i].children).length) {
              // console.log('aaa')
              this.checkAll[i] = true
            } else {
              this.checkAll[i] = false
            }
          }
          resolve()
        }).catch(error => {
          // console.log(error)
          reject(error)
        })
      })
    },
    //
    onChange () {
      // console.log(checkedList)
      // console.log(this.menuSelected)
      var list = []
      for (let i = 0; i < this.menuList.length; i++) {
        for (let j = 0; j < this.menuSelected[i].length; j++) {
          for (let k = 0; k < this.menuList[i].children.length; k++) {
            if (this.menuSelected[i][j] && this.menuSelected[i][j] === this.menuList[i].children[k].menuName) {
              // console.log(i, j, k)
              list.push(this.menuList[i].children[k].id)
            }
          }
        }
      }
      // console.log(this.menuSelected)
      this.model.menuIds = list
      //
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuSelected[i] !== [] && this.menuSelected[i].length === this.toList(this.menuList[i].children).length) {
          this.checkAll[i] = true
        } else {
          this.checkAll[i] = false
        }
      }
      // this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
      // this.checkAll = checkedList.length === plainOptions.length
    },
    onCheckAllChange (index) {
      console.log(this.toList(this.menuList[index].children))
      console.log(this.menuSelected[index])
      if (this.menuSelected[index] !== [] && this.menuSelected[index].length === this.toList(this.menuList[index].children).length) {
        // console.log('aaa')
        this.menuSelected[index] = []
        this.checkAll[index] = false
      } else {
        this.menuSelected[index] = this.toList(this.menuList[index].children)
        this.checkAll[index] = true
      }
      //
      var list = []
      for (let i = 0; i < this.menuList.length; i++) {
        for (let j = 0; j < this.menuSelected[i].length; j++) {
          for (let k = 0; k < this.menuList[i].children.length; k++) {
            if (this.menuSelected[i][j] && this.menuSelected[i][j] === this.menuList[i].children[k].menuName) {
              // console.log(i, j, k)
              list.push(this.menuList[i].children[k].id)
            }
          }
        }
      }
      console.log(list)
      this.model.menuIds = list
    },
    //
    toList (data) {
      var list = []
      for (let i = 0; i < data.length; i++) {
        list.push(data[i].menuName)
      }
      return list
    }
  },
  created () {
    console.log('custom modal created')

    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))

    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      console.log(this.model)
      this.getMenu()
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  }
}
</script>
<style lang="less" scoped>
.usedArea{
  span{
    color:blue;
    margin-right:10px;
  }
  span:hover{
    cursor: pointer;
  }
}
</style>
